/** Espelha `GET /v1/admin/audit` (ADR-007 D-7). */
export interface AuditEventDto {
  id: string
  at: string
  /**
   * Impressão digital da admin key usada, não uma pessoa: o admin autentica por segredo
   * compartilhado e ainda não tem identidade individual.
   */
  actor: string
  /**
   * Opcionais de verdade, não nulos: o Jackson da API está com NON_NULL, então campos sem valor
   * chegam ausentes do JSON em vez de null.
   */
  source_ip?: string
  /** `key.create`, `key.update`, `key.revoke`, `setting.update`, `setting.locked`, `auth.denied`. */
  action: string
  target?: string
  tenant_id?: string
  field?: string
  old_value?: string
  new_value?: string
  /** `ok`, `denied` ou `error`. */
  outcome: string
}

export interface AuditListResponse {
  events: AuditEventDto[]
  total: number
}

export const AUDIT_ACTIONS = [
  { value: 'key.create', label: 'Chave criada' },
  { value: 'key.update', label: 'Chave alterada' },
  { value: 'key.revoke', label: 'Chave revogada' },
  { value: 'setting.update', label: 'Configuração alterada' },
  { value: 'setting.locked', label: 'Alteração barrada por cadeado' },
  { value: 'auth.denied', label: 'Acesso recusado' },
]

const ACTION_LABEL: Record<string, string> = Object.fromEntries(
  AUDIT_ACTIONS.map((action) => [action.value, action.label]),
)

export function actionLabel(action: string): string {
  return ACTION_LABEL[action] ?? action
}

/** Vermelho para o que foi recusado — é o que se procura ao abrir esta tela. */
export function outcomeColor(outcome: string): string {
  if (outcome === 'denied') return 'red'
  if (outcome === 'error') return 'orange'
  return 'green'
}
